import { entityAPI, logAPI } from "api/GenericAPI";
import { TextMessage , TextMessageLog } from "api/Interactions/InteractionsInterfaces";


export const textMessageAPI = entityAPI<TextMessage>("interactions", "textmessages");
export const textMessageLogAPI = logAPI<TextMessageLog>("interactions", "textmessages");


